import appConstants from '@appConstants';

const getParentMessageIds = (messages) => {
  return messages.filter((msg) => msg.parentMessageId).map((msg) => msg.parentMessageId);
};

const getDispatcherNameForReplyThread = (message, parentMessage) => {
  // Driver reply: quoted block is the dispatcher message; receiver on the reply row is often empty.
  if (parentMessage.messageType === appConstants.MESSAGE_TYPE.Dispatcher) {
    return parentMessage.sender;
  }
  // Dispatcher reply: show the replying dispatcher, not the quoted driver message.
  if (message.messageType === appConstants.MESSAGE_TYPE.Dispatcher) {
    return message.sender;
  }
  return message.receiver;
};

const getDispatcherName = (message) => {
  const parentMessage = message.parentMessage;
  const hasReplyParent =
    parentMessage && Object.keys(parentMessage).length > 0;

  if (hasReplyParent) {
    return getDispatcherNameForReplyThread(message, parentMessage);
  }

  if (message.messageType === appConstants.MESSAGE_TYPE.Dispatcher) {
    return message.sender;
  }
  return message.receiver;
};

const getPreparedMessageData = (messages) => {
  const parentMessageIds = getParentMessageIds(messages);
  return messages
    .reduce((filteredMessages, element) => {
      if (!element.message || parentMessageIds.includes(element.messageId)) {
        return filteredMessages;
      }
      let parentMessage = {};
      if (element.parentMessageId) {
        parentMessageIds.push(element.parentMessageId);
        parentMessage = messages.find((msg) => msg.messageId === element.parentMessageId) ?? {};
      }
      return [...filteredMessages, { ...element, type: 'text', parentMessage }];
    }, [])
    .sort((a, b) => new Date(a.messageDateTs) - new Date(b.messageDateTs));
};

export { getPreparedMessageData, getDispatcherName };
